export default __webpack_public_path__ + "static/media/icon-menu-mobile.ab2d1a3e.svg";